module.exports = __webpack_public_path__ + "static/media/20220716-steffi-dwitdollyo-bruchtest.25380934.jpg";